export var NotificationEventType;
(function (NotificationEventType) {
    NotificationEventType["KYC_REMINDER"] = "KYC_REMINDER";
    NotificationEventType["KYC_COMPLETED"] = "KYC_COMPLETED";
    NotificationEventType["KYC_REJECTED"] = "KYC_REJECTED";
    NotificationEventType["KYC_EXPIRED"] = "KYC_EXPIRED";
    NotificationEventType["KYC_DECLINED"] = "KYC_DECLINED";
    NotificationEventType["PLAN_SELECTION_REMINDER"] = "PLAN_SELECTION_REMINDER";
    NotificationEventType["TOP_UP_REMINDER"] = "TOP_UP_REMINDER";
    NotificationEventType["ORDER_PHYSICAL_CARD"] = "ORDER_PHYSICAL_CARD";
    NotificationEventType["TOP_UP_TRADEVEST"] = "TOP_UP_TRADEVEST";
    NotificationEventType["INVEST_NOW"] = "INVEST_NOW";
    NotificationEventType["CARD_EXPIRES"] = "CARD_EXPIRES";
    NotificationEventType["BALANCE_LOW"] = "BALANCE_LOW";
    NotificationEventType["STANDING_ORDER_LOW_BALANCE"] = "STANDING_ORDER_LOW_BALANCE";
    NotificationEventType["STANDING_ORDER_FAILED"] = "STANDING_ORDER_FAILED";
    NotificationEventType["STANDING_ORDER_SUCCESS"] = "STANDING_ORDER_SUCCESS";
    NotificationEventType["CRYPTO_PRICE_CHANGE"] = "CRYPTO_PRICE_CHANGE";
    NotificationEventType["BIRTHDAY"] = "BIRTHDAY";
    NotificationEventType["MONEY_RECEIVED"] = "MONEY_RECEIVED";
    NotificationEventType["SPARPLAN_TRIGGERED"] = "SPARPLAN_TRIGGERED";
    NotificationEventType["SPARPLAN_BUY_SUCCEEDED"] = "SPARPLAN_BUY_SUCCEEDED";
    NotificationEventType["SPARPLAN_BUY_FAILED"] = "SPARPLAN_BUY_FAILED";
    NotificationEventType["FINAPI_CONSENT_EXPIRING"] = "FINAPI_CONSENT_EXPIRING";
    NotificationEventType["FINAPI_CONSENT_RENEWAL_REQUIRED"] = "FINAPI_CONSENT_RENEWAL_REQUIRED";
    NotificationEventType["TRADEVEST_ORDER_EXECUTED"] = "TRADEVEST_ORDER_EXECUTED";
    NotificationEventType["TRADEVEST_ORDER_FAILED"] = "TRADEVEST_ORDER_FAILED";
    NotificationEventType["TRADEVEST_ORDER_SETTLED"] = "TRADEVEST_ORDER_SETTLED";
    NotificationEventType["TRADEVEST_DIVIDEND_CREDITED"] = "TRADEVEST_DIVIDEND_CREDITED";
    NotificationEventType["TRADEVEST_CORPORATE_ACTION_SETTLED"] = "TRADEVEST_CORPORATE_ACTION_SETTLED";
})(NotificationEventType || (NotificationEventType = {}));
export var NotificationChannel;
(function (NotificationChannel) {
    NotificationChannel["PUSH"] = "PUSH";
    NotificationChannel["WHATSAPP"] = "WHATSAPP";
    NotificationChannel["EMAIL"] = "EMAIL";
    NotificationChannel["SMS"] = "SMS";
    NotificationChannel["IN_APP_BANNER"] = "IN_APP_BANNER";
})(NotificationChannel || (NotificationChannel = {}));
export var NotificationCategoryType;
(function (NotificationCategoryType) {
    NotificationCategoryType["TRANSACTIONAL"] = "TRANSACTIONAL";
    NotificationCategoryType["PROMOTIONAL"] = "PROMOTIONAL";
    NotificationCategoryType["INFORMATIONAL"] = "INFORMATIONAL";
})(NotificationCategoryType || (NotificationCategoryType = {}));
export var NotificationEventStatus;
(function (NotificationEventStatus) {
    NotificationEventStatus["PENDING"] = "PENDING";
    NotificationEventStatus["PROCESSING"] = "PROCESSING";
    NotificationEventStatus["COMPLETED"] = "COMPLETED";
    NotificationEventStatus["FAILED"] = "FAILED";
    NotificationEventStatus["CANCELLED"] = "CANCELLED";
})(NotificationEventStatus || (NotificationEventStatus = {}));
export var ChannelAttemptStatus;
(function (ChannelAttemptStatus) {
    ChannelAttemptStatus["SUCCESS"] = "SUCCESS";
    ChannelAttemptStatus["FAILED"] = "FAILED";
    ChannelAttemptStatus["SKIPPED"] = "SKIPPED";
})(ChannelAttemptStatus || (ChannelAttemptStatus = {}));
export var NotificationFinalStatus;
(function (NotificationFinalStatus) {
    NotificationFinalStatus["DELIVERED"] = "DELIVERED";
    NotificationFinalStatus["FAILED"] = "FAILED";
    NotificationFinalStatus["CANCELLED"] = "CANCELLED";
    NotificationFinalStatus["OPTED_OUT"] = "OPTED_OUT";
})(NotificationFinalStatus || (NotificationFinalStatus = {}));
export var TriggerType;
(function (TriggerType) {
    TriggerType["SCHEDULED"] = "SCHEDULED";
    TriggerType["IMMEDIATE"] = "IMMEDIATE";
})(TriggerType || (TriggerType = {}));
export var TriggerOperator;
(function (TriggerOperator) {
    TriggerOperator["EQ"] = "eq";
    TriggerOperator["NEQ"] = "neq";
    TriggerOperator["GT"] = "gt";
    TriggerOperator["LT"] = "lt";
    TriggerOperator["EXISTS"] = "exists";
    TriggerOperator["NOT_EXISTS"] = "not_exists";
    TriggerOperator["IN"] = "in";
    TriggerOperator["AGE_DAYS_GT"] = "age_days_gt";
    TriggerOperator["AGE_DAYS_LT"] = "age_days_lt";
    TriggerOperator["BIRTHDAY_TODAY"] = "birthday_today";
})(TriggerOperator || (TriggerOperator = {}));
export var NotificationScheduleStatus;
(function (NotificationScheduleStatus) {
    NotificationScheduleStatus["PENDING"] = "PENDING";
    NotificationScheduleStatus["PROCESSING"] = "PROCESSING";
    NotificationScheduleStatus["SENT"] = "SENT";
    NotificationScheduleStatus["CANCELLED"] = "CANCELLED";
})(NotificationScheduleStatus || (NotificationScheduleStatus = {}));
export var InAppBannerStatus;
(function (InAppBannerStatus) {
    InAppBannerStatus["ACTIVE"] = "ACTIVE";
    InAppBannerStatus["DISMISSED"] = "DISMISSED";
    InAppBannerStatus["EXPIRED"] = "EXPIRED";
})(InAppBannerStatus || (InAppBannerStatus = {}));
export var BannerTargetScreen;
(function (BannerTargetScreen) {
    BannerTargetScreen["COCKPIT"] = "COCKPIT";
    BannerTargetScreen["CRYPTO_WALLET"] = "CRYPTO_WALLET";
    BannerTargetScreen["BANK_ACCOUNT"] = "BANK_ACCOUNT";
    BannerTargetScreen["CARD"] = "CARD";
    BannerTargetScreen["ALL"] = "ALL";
})(BannerTargetScreen || (BannerTargetScreen = {}));
export var NotificationTriggeredBy;
(function (NotificationTriggeredBy) {
    NotificationTriggeredBy["SYSTEM"] = "SYSTEM";
    NotificationTriggeredBy["STAFF"] = "STAFF";
})(NotificationTriggeredBy || (NotificationTriggeredBy = {}));
//# sourceMappingURL=notification-system.types.js.map